<h2 class="bd-title">Database Connections</h2>
@if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
} @if (successMessage) {
<alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
  <coso-alert-message>{{ successMessage }}</coso-alert-message>
</alert>
} @if ({ isLoading: loadingService.isAnySpinnerActive$ | async }; as loadingState) { @if (!loadingState.isLoading) {
<coso-grid [gridOptions]="gridOptions" [rowData]="connections" [searchable]="true">
  <div topBarLeft>
    <button
      id="createButton"
      class="btn btn-sm btn-primary"
      [disabled]="isReadOnly"
      (click)="openAddEditModal()"
      placement="top"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="Create a new database connection"
    >
      <span class="fa fa-plus mr-1" aria-hidden="true"></span>Create new
    </button>
  </div>
</coso-grid>
} }

<ng-template #actionButtons let-params="params">
  <div class="grid-btnActions btn-group-sm" role="group">
    <button
      id="editActionButton#{{ params.data.databaseConnectionHolder.name }}"
      class="btn btn-dark mr-1"
      (click)="openAddEditModal(params.data)"
      data-toggle="tooltip"
      [title]="isReadOnly ? 'View database connection details' : 'Edit database connection'"
      [attr.aria-label]="(isReadOnly ? 'View database connection details of ' : 'Edit database connection ') + params.data.databaseConnectionHolder.name"
    >
      <span class="fa fa-fw {{ isReadOnly ? 'fa-eye' : 'fa-edit' }}" aria-hidden="true"></span>
    </button>
    <button
      id="deleteActionButton#{{ params.data.databaseConnectionHolder.name }}"
      class="btn btn-danger"
      data-toggle="tooltip"
      title="Delete database connection"
      [disabled]="isReadOnly || params.data.isCurrentlyInUse || connections.length === 1"
      (click)="openDeleteModal(params.data)"
      [attr.aria-label]="'Delete database connection ' + params.data.databaseConnectionHolder.name + '?'"
    >
      <span class="fa fa-fw fa-trash" aria-hidden="true"></span>
    </button>
  </div>
</ng-template>
